export const PHONE_NUMBER_COUNTRIES = [
  { id: 'dk', dialingCode: '+45' },
  { id: 'se', dialingCode: '+46' },
  { id: 'no', dialingCode: '+47' },
  { id: 'fi', dialingCode: '+358' },
] as const;

export type PhoneNumberCountry = (typeof PHONE_NUMBER_COUNTRIES)[number]['id'];

const PHONE_NUMBER_DIALING_CODES = Object.fromEntries(
  PHONE_NUMBER_COUNTRIES.map(({ id, dialingCode }) => [id, dialingCode]),
) as Record<PhoneNumberCountry, string>;

const PHONE_NUMBER_RULES = {
  no: /^\d{8}$/,
  fi: /^\d{9,10}$/,
  se: /^(07\d{8}|7\d{8})$/,
  dk: /^[5-9]\d{7}$/,
} as const satisfies Record<PhoneNumberCountry, RegExp>;

export const sanitizePhoneNumber = (value: string) =>
  value.replaceAll(/[^\d]/g, '');

export const isValidPhoneNumber = (
  value: string,
  country: PhoneNumberCountry,
) => PHONE_NUMBER_RULES[country].test(sanitizePhoneNumber(value));

export const parsePhoneNumberInput = (
  value: string,
  currentCountry: PhoneNumberCountry,
) => {
  const country = PHONE_NUMBER_COUNTRIES.find(({ dialingCode }) =>
    value.startsWith(dialingCode),
  );

  return {
    country: country?.id ?? currentCountry,
    number: sanitizePhoneNumber(
      country ? value.slice(country.dialingCode.length) : value,
    ),
  };
};

export const formatInternationalPhoneNumber = (
  value: string,
  country: PhoneNumberCountry,
) => {
  const nationalNumber = sanitizePhoneNumber(value).replace(/^0/, '');

  return `${PHONE_NUMBER_DIALING_CODES[country]}${nationalNumber}`;
};
